import { useCallback, useEffect, useState } from 'react'
import { healthApi, type HealthReport, type ValidatorCategory } from '../../../../sdk/health.api'
import { getShop } from '../../../../sdk/shop'

export function useHealthReport() {
  const shop = getShop() ?? ''
  const [report,   setReport]   = useState<HealthReport | null>(null)
  const [loading,  setLoading]  = useState(true)
  const [error,    setError]    = useState<string | null>(null)
  const [scanning, setScanning] = useState(false)

  const fetchReport = useCallback(async () => {
    if (!shop) return
    setLoading(true)
    setError(null)
    try {
      const r = await healthApi.getReport(shop)
      setReport(r)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load health report')
    } finally {
      setLoading(false)
    }
  }, [shop])

  const runScan = useCallback(async (categories?: ValidatorCategory[]) => {
    if (!shop) return
    setScanning(true)
    setError(null)
    try {
      const r = await healthApi.runScan(shop, categories)
      setReport(r)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Health scan failed')
    } finally {
      setScanning(false)
    }
  }, [shop])

  const updateReport = useCallback((updated: HealthReport) => {
    setReport(updated)
  }, [])

  useEffect(() => { fetchReport() }, [fetchReport])

  return { report, loading, error, scanning, refresh: fetchReport, runScan, updateReport }
}
